import React from "react";
import { useLocation, useHistory } from "react-router-dom";

import { Tabs, Tab } from "react-bootstrap";
import AnnualReportList from "../AnnualReportList/AnnualReportList";
import SustainabilityReportList from "../SustainabilityReportList/SustainabilityReportList";
import { useTranslation } from "react-i18next";

import "./Tabs.scss";

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const AnnualReportTabs = () => {
  const {t} = useTranslation();
  const query = useQuery();
  const history = useHistory();

  const handleTab = key => {
    history.push({
      search: `?tab=${key}&page=1`
    })
  }

  const activeKey = query.get("tab") || "annual-report";
  const page = query.get("page") || 1;
  return (
    <div className="annual-report-tabs">
      <Tabs
        activeKey={activeKey}
        onSelect={(k) => handleTab(k)}
        transition={false}
        id="annual-report"
        className="mb-3"
      >
        <Tab eventKey="annual-report" title={t("laporan_tahunan")}>
          <AnnualReportList page={page} active={activeKey === "annual-report"} />
        </Tab>
        <Tab eventKey="sustainability-report" title={t("laporan_keberlanjutan")}>
          <SustainabilityReportList page={page} active={activeKey === "sustainability-report"} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default AnnualReportTabs;
